import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { QuoteServiceAddReview as Review } from './quoteReviewContract';
import { QuoteConfirmationReview } from './QuoteConfirmationReview';

export function QuoteServiceAddReview({ review }: { review: Review }) {
  const { t, i18n } = useTranslation('assistant');
  const money = (cents: number) =>
    new Intl.NumberFormat(i18n.resolvedLanguage ?? i18n.language, {
      style: 'currency',
      currency: review.result.pricing.currency,
    }).format(cents / 100);
  return (
    <Box data-testid="quote-service-add-review">
      <Typography variant="subtitle2">{t('quoteServiceAdd.result')}</Typography>
      <Typography variant="body2" color="primary" data-testid="quote-service-added">
        {t('quoteServiceAdd.added', {
          service: review.result.services[review.quote.services.length]?.name,
        })}
      </Typography>
      <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
        {t('quoteServiceAdd.summary', {
          before: review.summaryBefore ?? t('quoteReview.none'),
          after: review.summaryAfter,
        })}
      </Typography>
      <Typography variant="body2">
        {t('quoteReview.gross')}: {money(review.quote.pricing.grossTotalCents)} →{' '}
        {money(review.result.pricing.grossTotalCents)}
      </Typography>
      <Typography variant="body2">
        {t('quoteServiceAdd.duration', {
          before: review.quote.schedule.estimatedDurationHours ?? t('quoteReview.none'),
          after: review.result.schedule.estimatedDurationHours ?? t('quoteReview.none'),
        })}
      </Typography>
      {review.catalogParts.map((p, i) => (
        <Typography key={`${p.partCategoryId}-${i}`} variant="body2">
          {p.name} ·{' '}
          {t(p.isRequired ? 'quoteServiceAdd.requiredPart' : 'quoteServiceAdd.optionalPart')}
        </Typography>
      ))}
      <QuoteConfirmationReview review={{ action: 'serviceLine', quote: review.result }} />
      <Typography variant="body2" color="warning.main">
        {t('quoteServiceAdd.defaults')}
      </Typography>
      <Typography variant="body2">{t('quoteServiceAdd.noOtherEffects')}</Typography>
    </Box>
  );
}
